// extracted by mini-css-extract-plugin
export default {"container":"Robot_container__Xato+","panel":"Robot_panel__T-AK7","wrapper":"Robot_wrapper__hZ8Ab","info":"Robot_info__WRuij","unit":"Robot_unit__ZKk7J"};